import * as React from 'react';

import classNames from 'classnames';

import {deserializeFieldNames} from 'nutshell-core/entities/deserialize-fields';

import {Body} from 'shells/typography/body';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import {getReportDefaultFields} from '../../reports/report-constants';
import type {ReportURLParams} from '../../reports/report-types';

import {AudienceLastContactedTime} from './audience-last-contacted-time';

export function getAudienceSubtitle(props: {
    subscribersCount: number | null | undefined;
    isPublic: boolean;
    deletedTime: number | null | undefined;
}): React.ReactElement<any> {
    const subtitleParts = [getSubscribersCount(props.subscribersCount)];

    // If the audience is public, it means it's on the preference center
    if (props.isPublic) {
        subtitleParts.push('On preference center');
    }

    if (props.deletedTime) {
        subtitleParts.push('Archived');
    }

    const subtitle = subtitleParts.join(' · ');
    const archivedClass = classNames({
        'light-text': props.deletedTime,
    });

    return <div className={archivedClass}>{subtitle}</div>;
}

export function getSubscribersCount(subscribersCount?: number | null): string {
    if (!subscribersCount) {
        return '0 subscribers';
    }

    const pluralSubscribers = subscribersCount !== 1 ? 'subscribers' : 'subscriber';

    return `${subscribersCount.toLocaleString()} ${pluralSubscribers}`;
}

export function getPublicAudienceElement(
    publicName: string,
    publicDescription: string
): string | React.ReactElement<any> {
    return (
        <div className='flex flex-dir-col gap-4'>
            <Body isBold={true} size='small' color='dark'>
                Public name
            </Body>
            <div className='pb-8'>
                <Body size='small'>{publicName}</Body>
            </div>
            <Body isBold={true} size='small' color='dark'>
                Public description
            </Body>
            <Body size='small'>{publicDescription}</Body>
        </div>
    );
}

export function getSelectedFields(urlParams: ReportURLParams<'contacts'>) {
    const listParams = urlParams.list || {};

    // @ts-expect-error
    return listParams.fields && listParams.fields.contacts
        ? // @ts-expect-error
          deserializeFieldNames(listParams.fields.contacts)
        : deserializeFieldNames(getReportDefaultFields('audienceMembership'));
}

export function getStatusInfo(audience: AudienceFragment) {
    return {
        status: {
            level: audience.deletedTime ? 'hidden' : 'info',
            text: audience.deletedTime ? 'Archived' : 'Active',
        },
        primaryText:
            audience.membershipStats.totalCount.value === 1
                ? `${audience.membershipStats.totalCount.value.toLocaleString()} member`
                : `${audience.membershipStats.totalCount.value.toLocaleString()} members`,
        secondaryText: <AudienceLastContactedTime lastContactedTime={audience.lastContactedTime} />,
    };
}
